import React from 'react';
import '../css/innonita.css';

const landingHTML =`<!DOCTYPE html>
<html lang="en">
    <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <meta name="description" content="" />
        <meta name="author" content="" />
        <title>INNOUNITA</title>
        <!-- Favicon-->
        <link rel="icon" type="image/x-icon" href="assets/favicon.png" />
        <!-- Core theme CSS (includes Bootstrap)-->
        <link href="https://bit.ly/3Exc98U" rel="stylesheet" />
		<!-- Custom theme CSS -->
        <link href="https://bit.ly/3iWDxpV" rel="stylesheet" />
		<!-- Google Fonts CSS -->
		<link rel="preconnect" href="https://fonts.googleapis.com">
		<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
		<link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap" rel="stylesheet">
    </head>
    <body class="training-page">
        <!-- Responsive navbar-->
        <nav class="navbar navbar-expand-lg">
            <div class="container-fluid">
                <a class="navbar-brand" href="#"><img src="https://github.com/RaphaelCroitoriu/media-project-1.2/blob/main/assets/imgs/innounita-logo.png?raw=true" alt="INNOUNITA"></a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"><img src="https://raw.githubusercontent.com/RaphaelCroitoriu/media-project-1.2/3fc4b2f105dbe62cb8728edfbf9482245b09672e/assets/imgs/hamburger.svg"></span></button>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                        <li class="nav-item"><a class="nav-link" aria-current="page" href="/">Home</a></li>
                    </ul>
                </div>
            </div>
        </nav>
			

		<!-- Page Content -->
		<section id="training">
			<div class="container">
				<div class="row justify-content-center hero-block">
					<div class="col-xl-12 col-md-12 my-auto hero-content text-center">
						
							<h1 class="big-title training-title-page">Training</h1>
							<div class="training-element"></div>
							
					</div>
					
					<div class="col-xl-4 col-md-12 my-auto hero-content text-center">
						<img src="https://github.com/RaphaelCroitoriu/media-project-1.2/blob/main/assets/imgs/training-01.jpg?raw=true" alt="INNOUNITA - Training Programme" class="border-blu-1">
						<h3 class="training-subs">Training Programme</h3>
						<p class="lead mb-4">
						The general objective of the training programme is to give participants the
						knowledge and tools they need to set up their own business. Specifically, the programme should focus on
						the first steps of entrepreneurship: from the initial idea to the MVP.
						</p>
					</div>
					
					<div class="col-xl-4 col-md-12 my-auto hero-content text-center">
						<img src="https://github.com/RaphaelCroitoriu/media-project-1.2/blob/main/assets/imgs/training-02.jpg?raw=true" alt="INNOUNITA - Pitch Competition" class="border-blu-2">
						<h3 class="training-subs">Pitch Competition</h3>
						<p class="lead mb-4">
						An opportunity for PhDs and young researchers to promote entrepreneurship, to bring
						about networking opportunities through a federating international experience as well as showcase
						INNOUNITA entrepreneurial pipeline/pool.
						</p>
					</div>
					
					<div class="col-xl-4 col-md-12 my-auto hero-content text-center">
						<img src="https://github.com/RaphaelCroitoriu/media-project-1.2/blob/main/assets/imgs/training-03.jpg?raw=true" alt="INNOUNITA - Winter School" class="border-blu-1">
						<h3 class="training-subs">Winter School</h3>
						<p class="lead mb-4">
						Two days of acceleration program, structured as a training to the methodology of
						entrepreneurial project support and advisory, dedicated to academic and non-academic staff.
						</p>
					</div>
				</div>
        	</div>

		</section>
		
		
        <!-- Bootstrap core JS-->
        <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js"></script>
        <!-- Core theme JS-->
        <script src="https://bit.ly/3EWXWnf"></script>
    </body>
</html>
`

const Training = () => {
    return(
        <div><div dangerouslySetInnerHTML={{ __html: landingHTML }} />;</div>
    );
};

export default Training;
